import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Image,
  Input,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  Tooltip,
  useDisclosure,
} from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  DeleteOnedata,
  StringLimit,
  capitalize,
  getDataWithFilterUrl,
  separateDasFromUrl,
} from "../../controllers/APIController";
import UnifiedDeleteModal from "../../components/UnifiedDeleteModal";
import SearchIcon from "../../Images/Search";
import LoadingPage from "../../components/Loader/LoadingPage";
import NullData from "../../components/ErrorPage/NullData";
import TableSkeleton from "../../components/Skeleten/TableSkeleton";

const AllLibrary = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setisLoading] = useState(true);

  const [metricsList, setmetricsList] = useState([]);
  const [reRenderPage, setReRenderPage] = useState(0);
  const [deleteMetricId, setDeleteMetricId] = useState(-1);
  const [deleteItemData, setDeleteItemData] = useState({ id: -1, name: "" });
  const navigate = useNavigate();
  const { _orgId } = useParams();

  const { pathname } = useLocation();
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const paramList = ["", "factor library", "library"];
  let HeadingTitle = capitalize(separateDasFromUrl(paramList[2]));

  let filteredUrl = "filters[Metric_Id][$eqi]=" + HeadingTitle;

  let headers =
    metricsList.length !== 0
      ? Object.keys(metricsList[0]?.attributes?.JsonSchema)
      : [];

  const customizeCompleteList = [...headers];

  const [customizeItems, setCustomizeItems] = useState(new Set([...headers]));

  const coulmnDef = Array.from(customizeItems).map((name) => {
    return {
      id: name.toLowerCase(),
      label: name,
    };
  });

  const customizeHeaderList = [...coulmnDef];

  const EditHandler = (id) => {
    navigate(`/${_orgId}/factor-library/${id}`);
  };

  const deleteHandler = async () => {
    await DeleteOnedata("responses", deleteItemData.id);
    setReRenderPage((pre) => 1 - pre);
  };

  useEffect(() => {
    getDataWithFilterUrl("responses", filteredUrl)
      .then((data) => {
        setmetricsList(data.data);
        const headers =
          data?.data?.length !== 0
            ? Object.keys(data.data[0]?.attributes?.JsonSchema)
            : [];

        setCustomizeItems(new Set([...headers]));
        setisLoading(false);
      })
      .catch((err) => {
        // Handle error silently
      });
  }, [reRenderPage, filteredUrl]);

  // Filter metrics entry based on the search term and selected filter
  const filteredMetrics = metricsList.filter((item) => {
    const formEntry = item?.attributes?.JsonSchema;
    let result = false;
    Object.keys(formEntry).forEach((key) => {
      result =
        result |
        (typeof formEntry[key] == "string" &&
          formEntry[key].toLowerCase().includes(searchTerm.toLowerCase()));
    });

    return result;
  });

  const ItemPerPage = 20;
  const totalPage = Math.ceil(filteredMetrics.length / ItemPerPage);

  return (
    <>
      {
        <UnifiedDeleteModal
          isOpen={isOpen}
          onOpenChange={onOpenChange}
          onConfirm={deleteHandler}
          title="Delete Library Entry"
          message="Are you sure you want to delete"
          confirmText="Delete Entry"
          cancelText="Cancel"
          itemName={deleteItemData.name}
        />
      }
      <div className="flex justify-end my-4">
        <Button
          color="primary"
          className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium"
          size="sm"
          onClick={() => {
            navigate(`${pathname}/create`);
          }}
        >
          + Create a Factor Library
        </Button>
      </div>
      <div>
        <Input
          type="text"
          startContent={
            <SearchIcon
              className={`text-large text- pointer-events-none flex-shrink-0 `}
            />
          }
          placeholder="Search any entry"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <LoadingPage isLoading={isLoading} alterElement={<TableSkeleton />}>
        {filteredMetrics.length > 0 ? (
          <>
            {filteredMetrics.length > 0 && (
              <div className="flex justify-end my-4 gap-2">
                {/* <Dropdown className="w-max">
            <DropdownTrigger>
              <Button
                size="sm"
                variant="light"
                className="w-max bg-warmGray-300"
              >
                Sort
              </Button>
            </DropdownTrigger>
            <DropdownMenu
              aria-label="Static Actions"
              variant="flat"
              selectionMode="single"
              defaultSelectedKeys={new Set([sortedBy])}
              selectedKeys={new Set([sortedBy])}
              onSelectionChange={(event) => {
                setSortedBy(Array.from(event).join(", ").replaceAll("_", " "));
              }}
            >
              {sortingItemList.map((item) => (
                <DropdownItem key={item.key}>{item.name}</DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown> */}
                <Dropdown className="w-max">
                  <DropdownTrigger>
                    <Button
                      size="sm"
                      variant="light"
                      className="w-max bg-warmGray-300"
                    >
                      Customize
                    </Button>
                  </DropdownTrigger>
                  <DropdownMenu
                    aria-label="Multiple selection"
                    variant="flat"
                    closeOnSelect={false}
                    selectionMode="multiple"
                    disallowEmptySelection
                    selectedKeys={customizeItems}
                    onSelectionChange={setCustomizeItems}
                  >
                    {customizeCompleteList.map((name) => (
                      <DropdownItem key={name}>{name}</DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </div>
            )}

            <div className="overflow-x-auto custom-scrollbar pb-8">
              {filteredMetrics.length > 0 && (
                <Table
                  removeWrapper
                  className="mt-8"
                  selectionMode="single"
                  aria-label="all-library-table"
                >
                  <TableHeader>
                    {customizeHeaderList.map((header) => (
                      <TableColumn key={header.id}>{header.label}</TableColumn>
                    ))}
                    <TableColumn key={headers.length}>Actions</TableColumn>
                  </TableHeader>

                  <TableBody>
                    {filteredMetrics.length !== 0 &&
                      filteredMetrics.map((item, index) => {
                        const lowerPageLimit = (currentPage - 1) * ItemPerPage;
                        const upperPageLimit = currentPage * ItemPerPage;
                        if (index < lowerPageLimit || index >= upperPageLimit)
                          return null;
                        return (
                          <TableRow
                            key={item.id}
                            onClick={() => EditHandler(item.id)}
                            className="cursor-pointer"
                          >
                            {customizeHeaderList.map(({ label: key }) => {
                              if (
                                item?.attributes?.JsonSchema[key] === "null"
                              ) {
                                return <TableCell>-</TableCell>;
                              }
                              if (
                                typeof item?.attributes?.JsonSchema[key] ===
                                "object"
                              ) {
                                return (
                                  <TableCell>
                                    <Image
                                      href="#"
                                      style={{ cursor: "pointer" }}
                                      size={26}
                                      onClick={() => {
                                        window.open(
                                          process.env
                                            .REACT_APP_STRAPI_IP_ADDRESS +
                                            item?.attributes?.JsonSchema[key]
                                              .url
                                        );
                                      }}
                                    />
                                  </TableCell>
                                );
                              }
                              return (
                                <TableCell>
                                  {typeof item?.attributes?.JsonSchema[key] ===
                                  "string"
                                    ? StringLimit(
                                        item?.attributes?.JsonSchema[key],
                                        40
                                      )
                                    : item?.attributes?.JsonSchema[key]}
                                </TableCell>
                              );
                            })}

                            <TableCell>
                              <div className="flex gap-4 text-center">
                                <div
                                  className="cursor-pointer"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    // Get item name from JsonSchema for display
                                    const itemName = Object.values(item?.attributes?.JsonSchema || {})
                                      .find(value => typeof value === 'string' && value !== 'null' && value.length > 0) || `Entry #${item.id}`;
                                    setDeleteItemData({ id: item.id, name: itemName });
                                    onOpen();
                                  }}
                                >
                                  <Tooltip size="sm" content="Delete Item">
                                    <lord-icon
                                      src="https://cdn.lordicon.com/wpyrrmcq.json"
                                      trigger="hover"
                                      
                                      style={{ width: "20px", height: "20px" }}
                                    ></lord-icon>
                                  </Tooltip>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              )}
            </div>
            {filteredMetrics.length > 0 && (
              <div className="w-full mt-8 flex items-center justify-center">
                <Pagination
                  showControls
                  total={totalPage}
                  color="secondary"
                  page={currentPage}
                  onChange={setCurrentPage}
                />
              </div>
            )}
          </>
        ) : (
          <NullData />
        )}
      </LoadingPage>
    </>
  );
};

export default AllLibrary;
